export { CustomMarker1 as default } from "./CustomMarker1";
